import { ROUTE_NAME } from '@/router/route-name';
import { ref, computed } from '@vue/composition-api';
import { Route } from 'vue-router';

const routeRef = ref<string[]>([]);

/**
 * traceRoutesを記録します。
 * @param route
 */
export const onRouteChange = (route: Route) => {
  if (route.name === ROUTE_NAME.HOME) {
    // ホームに戻った時は記録をリセットする。
    routeRef.value = [];
  } else {
    routeRef.value = [...routeRef.value, route.path];
  }
};

/**
 * javascriptErrorAPIに送信するためのtraceRoutesを提供する。
 * @returns
 */
const useTraceRoutes = () => computed(() => JSON.stringify(routeRef.value));

export default useTraceRoutes;
